import React from 'react';

const Home = (props) => {
    return <div>Zdravo svete</div>
};

export default Home;